import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

function Login() {
  return (
    <>
      <Navbar />
        <div>Login</div>
      <Footer />
    </>

  )
}

export default Login